import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const ChartUpIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M21.0002 13.3302C20.735 13.3302 20.4807 13.1897 20.2932 12.9398C20.1057 12.6898 20.0004 12.3508 20.0004 11.9973V8.54512L13.7117 16.9423C13.6188 17.0672 13.5082 17.1663 13.3863 17.234C13.2645 17.3017 13.1338 17.3365 13.0018 17.3365C12.8699 17.3365 12.7392 17.3017 12.6173 17.234C12.4955 17.1663 12.3849 17.0672 12.292 16.9423L9.00266 12.5438L3.71374 19.608C3.52548 19.859 3.27013 20 3.00389 20C2.73764 20 2.4823 19.859 2.29403 19.608C2.10577 19.357 2 19.0166 2 18.6617C2 18.3067 2.10577 17.9663 2.29403 17.7153L8.2928 9.71805C8.38575 9.59312 8.49633 9.49396 8.61816 9.42629C8.74 9.35863 8.87067 9.32379 9.00266 9.32379C9.13464 9.32379 9.26532 9.35863 9.38716 9.42629C9.50899 9.49396 9.61957 9.59312 9.71251 9.71805L13.0018 14.1166L18.5907 6.66576H16.0012C15.7361 6.66576 15.4818 6.52533 15.2943 6.27537C15.1068 6.0254 15.0014 5.68638 15.0014 5.33288C15.0014 4.97938 15.1068 4.64035 15.2943 4.39039C15.4818 4.14043 15.7361 4 16.0012 4H21.0002C21.1309 4.00211 21.2599 4.03833 21.3801 4.10663C21.6244 4.24188 21.8186 4.5007 21.92 4.82639C21.9712 4.98663 21.9984 5.1587 22 5.33288V11.9973C22 12.3508 21.8947 12.6898 21.7072 12.9398C21.5197 13.1897 21.2654 13.3302 21.0002 13.3302Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
